var __jsx = React.createElement;
import React from 'react';
import useIsMobile from '@hooks/useIsMobile';
import { useTranslation } from "@i18n";
import bannerMobile from '../icons/banner_mobile.png';
import bannerDesktop from '../icons/banner_desktop.png';
var FlatBanner = function FlatBanner(_ref) {
  var id = _ref.id;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(['sell_trade_landing']),
    tShort = _useTranslation.tShort;
  var bannerImage = isMobile ? bannerMobile : bannerDesktop;
  return /*#__PURE__*/React.createElement("div", {
    id: id !== null && id !== void 0 ? id : "flat-banner-container",
    className: "relative w-full"
  }, /*#__PURE__*/React.createElement("img", {
    id: "flat-banner-image",
    loading: "lazy",
    src: bannerImage,
    alt: tShort('banner/subtitle', {
      ns: 'sell_trade_landing'
    }),
    className: "w-full h-auto object-cover"
  }), /*#__PURE__*/React.createElement("div", {
    id: "flat-banner-text-overlay",
    className: "absolute inset-0 flex flex-col items-center justify-center text-center px-4"
  }, /*#__PURE__*/React.createElement("p", {
    id: "flat-banner-title",
    className: "text-white font-bold text-[18px] md:text-[30px] leading-snug"
  }, tShort('banner/title', {
    ns: 'sell_trade_landing'
  })), /*#__PURE__*/React.createElement("p", {
    id: "flat-banner-subtitle",
    className: "text-white font-bold text-[24px] md:text-[48px] leading-tight mt-1 md:mt-3"
  }, tShort('banner/subtitle', {
    ns: 'sell_trade_landing'
  }))));
};
export default FlatBanner;